// K52 butir 4 — unlock darurat FA terkunci oleh Kepala Cabang wilayahnya (AUDIT-B2, 23 Sep 2026).
//
// Pesan trigger DB selama ini menyuruh "Minta Kepala Cabang region ini membuka kunci darurat dulu",
// padahal tidak ada satu tombol pun untuk itu. Komponen ini PINTU-nya; peran, wilayah, alasan, dan
// jendela waktu ditegakkan backend (`routers/fa.py` + trigger `fa_orders_gerbang_kunci`). Unlock
// berbentuk JENDELA yang pulih sendiri — tidak ada "buka permanen".
import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";
import { formatDateTime } from "../../lib/format";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

export default function KunciDaruratFa({ fa, onSelesai }) {
  const [alasan, setAlasan] = useState("");
  const [sibuk, setSibuk] = useState(false);
  // Jawaban endpoint dipakai SEKETIKA (bukti layar 24 Sep 2026: memuat ulang FA penuh makan > 10 dtk,
  // kartu tampak belum berubah sesudah toast sukses). Data FA yang dimuat ulang tetap menang begitu tiba.
  const [segar, setSegar] = useState(null);
  if (!fa || fa.lock_mode === "EXEMPT") return null;
  const kini = segar && segar.id === fa.id && segar.dari === fa.lock_override_until ? { ...fa, ...segar.baris } : fa;
  const sampai = kini.lock_override_until ? new Date(kini.lock_override_until) : null;
  const terbuka = sampai && sampai > new Date();

  async function jalankan(jalur, body, pesan) {
    setSibuk(true);
    try {
      const r = await api.post(`/fa-orders/${fa.id}/${jalur}`, body);
      setSegar({ id: fa.id, dari: fa.lock_override_until, baris: r.data || {} });
      toast.success(pesan);
      setAlasan("");
      onSelesai && onSelesai();
    } catch (e) {
      toast.error(apiErrorMessage(e, "Gagal."));
    } finally {
      setSibuk(false);
    }
  }

  return (
    <div className="rounded-md border border-border p-3 text-sm space-y-2" data-testid="fa-kunci-darurat">
      <div className="font-medium">Kunci FA (Kepala Cabang)</div>
      {terbuka ? (
        <>
          <p>
            Kunci <b>dibuka sampai {formatDateTime(kini.lock_override_until)}</b> — alasan: {kini.lock_override_reason}
          </p>
          <Button size="sm" variant="outline" disabled={sibuk}
                  onClick={() => jalankan("kunci-kembali", undefined, "FA dikunci kembali.")}
                  data-testid="fa-kunci-kembali">Kunci kembali sekarang</Button>
        </>
      ) : (
        <>
          <p className="text-xs text-muted-foreground">
            Bila FA sudah terkunci (kolom komersial tidak bisa diubah), Kepala Cabang dapat membuka
            kunci darurat selama beberapa jam. Alasan wajib dan tercatat di jejak FA dan audit.
          </p>
          <Textarea value={alasan} onChange={(e) => setAlasan(e.target.value)} rows={2} maxLength={1000}
                    placeholder="Alasan membuka kunci (minimal 10 huruf)" data-testid="fa-unlock-alasan" />
          <Button size="sm" disabled={sibuk || alasan.trim().length < 10}
                  onClick={() => jalankan("buka-kunci-darurat", { alasan: alasan.trim() }, "Kunci FA dibuka sementara.")}
                  data-testid="fa-unlock-btn">Buka kunci darurat</Button>
        </>
      )}
    </div>
  );
}
